/* ============================================================
   Announcement bar behavior
   - SLIDE mode: cycles through messages, holds N seconds each
   - SCROLL mode: duplicates track for seamless infinite marquee,
     calculates duration from speed (px/s)
   - STATIC mode: no JS needed (CSS handles it)
   ============================================================ */
(function () {
  'use strict';

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initSlide(bar) {
    const msgs = bar.querySelectorAll('.hsg-announcement__msg');
    if (msgs.length === 0) return;
    msgs[0].classList.add('is-active');
    if (msgs.length === 1) return;

    const hold = (parseInt(bar.dataset.hold, 10) || 5) * 1000;
    let i = 0;

    setInterval(() => {
      const current = msgs[i];
      const next = msgs[(i + 1) % msgs.length];
      current.classList.remove('is-active');
      current.classList.add('is-leaving');
      next.classList.add('is-active');

      // clean up the leaving class after the transition completes
      setTimeout(() => current.classList.remove('is-leaving'), 600);
      i = (i + 1) % msgs.length;
    }, hold);
  }

  function initScroll(bar) {
    const track = bar.querySelector('.hsg-announcement__track');
    if (!track) return;

    // Duplicate content for seamless loop
    track.innerHTML = track.innerHTML + track.innerHTML;

    // Calculate duration from speed: width / pxPerSec
    const speed = parseInt(bar.dataset.speed, 10) || 40;
    requestAnimationFrame(() => {
      const distance = track.scrollWidth / 2; // half because we duplicated
      const duration = distance / speed;
      track.style.setProperty('--marquee-duration', duration + 's');
    });
  }

  function init() {
    document.querySelectorAll('.hsg-announcement').forEach((bar) => {
      const mode = bar.dataset.mode;
      if (reduceMotion && mode === 'scroll') {
        // Fall back to static center
        bar.classList.remove('hsg-announcement--scroll');
        bar.classList.add('hsg-announcement--static');
        return;
      }
      if (mode === 'slide')  initSlide(bar);
      if (mode === 'scroll') initScroll(bar);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
